/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Lutely API
 * Lutely API
 * OpenAPI spec version: local
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";

import type { UpdatePersonasDto, UserProfileDto } from ".././dtos";

import { apiRequest } from "../../api-request";
import type { ErrorType, BodyType } from "../../api-request";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const profileControllerUpdatePersonas = (
  updatePersonasDto: BodyType<UpdatePersonasDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/profile/personas`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: updatePersonasDto,
      signal,
    },
    options,
  );
};

export const getProfileControllerUpdatePersonasMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof profileControllerUpdatePersonas>>,
    TError,
    { data: BodyType<UpdatePersonasDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof profileControllerUpdatePersonas>>,
  TError,
  { data: BodyType<UpdatePersonasDto> },
  TContext
> => {
  const mutationKey = ["profileControllerUpdatePersonas"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof profileControllerUpdatePersonas>>,
    { data: BodyType<UpdatePersonasDto> }
  > = (props) => {
    const { data } = props ?? {};

    return profileControllerUpdatePersonas(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProfileControllerUpdatePersonasMutationResult = NonNullable<
  Awaited<ReturnType<typeof profileControllerUpdatePersonas>>
>;
export type ProfileControllerUpdatePersonasMutationBody =
  BodyType<UpdatePersonasDto>;
export type ProfileControllerUpdatePersonasMutationError = ErrorType<unknown>;

export const useProfileControllerUpdatePersonas = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof profileControllerUpdatePersonas>>,
      TError,
      { data: BodyType<UpdatePersonasDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof profileControllerUpdatePersonas>>,
  TError,
  { data: BodyType<UpdatePersonasDto> },
  TContext
> => {
  const mutationOptions =
    getProfileControllerUpdatePersonasMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const profileControllerDismissAudiolabBanner = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    { url: `/profile/audiolab-banner-dismissed`, method: "POST", signal },
    options,
  );
};

export const getProfileControllerDismissAudiolabBannerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof profileControllerDismissAudiolabBanner>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof profileControllerDismissAudiolabBanner>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["profileControllerDismissAudiolabBanner"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof profileControllerDismissAudiolabBanner>>,
    void
  > = () => {
    return profileControllerDismissAudiolabBanner(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProfileControllerDismissAudiolabBannerMutationResult = NonNullable<
  Awaited<ReturnType<typeof profileControllerDismissAudiolabBanner>>
>;

export type ProfileControllerDismissAudiolabBannerMutationError =
  ErrorType<unknown>;

export const useProfileControllerDismissAudiolabBanner = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof profileControllerDismissAudiolabBanner>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof profileControllerDismissAudiolabBanner>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getProfileControllerDismissAudiolabBannerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const profileControllerCollapseAudiolabBanner = (
  userProfileDto: BodyType<UserProfileDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/profile/audiolab-banner-collapsed`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: userProfileDto,
      signal,
    },
    options,
  );
};

export const getProfileControllerCollapseAudiolabBannerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof profileControllerCollapseAudiolabBanner>>,
    TError,
    { data: BodyType<UserProfileDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof profileControllerCollapseAudiolabBanner>>,
  TError,
  { data: BodyType<UserProfileDto> },
  TContext
> => {
  const mutationKey = ["profileControllerCollapseAudiolabBanner"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof profileControllerCollapseAudiolabBanner>>,
    { data: BodyType<UserProfileDto> }
  > = (props) => {
    const { data } = props ?? {};

    return profileControllerCollapseAudiolabBanner(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProfileControllerCollapseAudiolabBannerMutationResult = NonNullable<
  Awaited<ReturnType<typeof profileControllerCollapseAudiolabBanner>>
>;
export type ProfileControllerCollapseAudiolabBannerMutationBody =
  BodyType<UserProfileDto>;
export type ProfileControllerCollapseAudiolabBannerMutationError =
  ErrorType<unknown>;

export const useProfileControllerCollapseAudiolabBanner = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof profileControllerCollapseAudiolabBanner>>,
      TError,
      { data: BodyType<UserProfileDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof profileControllerCollapseAudiolabBanner>>,
  TError,
  { data: BodyType<UserProfileDto> },
  TContext
> => {
  const mutationOptions =
    getProfileControllerCollapseAudiolabBannerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const profileControllerMarkAudiolabTourSeen = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    { url: `/profile/audiolab-tour-seen`, method: "POST", signal },
    options,
  );
};

export const getProfileControllerMarkAudiolabTourSeenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof profileControllerMarkAudiolabTourSeen>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof profileControllerMarkAudiolabTourSeen>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["profileControllerMarkAudiolabTourSeen"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof profileControllerMarkAudiolabTourSeen>>,
    void
  > = () => {
    return profileControllerMarkAudiolabTourSeen(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProfileControllerMarkAudiolabTourSeenMutationResult = NonNullable<
  Awaited<ReturnType<typeof profileControllerMarkAudiolabTourSeen>>
>;

export type ProfileControllerMarkAudiolabTourSeenMutationError =
  ErrorType<unknown>;

export const useProfileControllerMarkAudiolabTourSeen = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof profileControllerMarkAudiolabTourSeen>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof profileControllerMarkAudiolabTourSeen>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getProfileControllerMarkAudiolabTourSeenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
